/* eslint-disable no-console */
import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { ErrorMessage } from 'formik';

const FormikCheckboxField = ({
  field: { ...fields },
  form: { touched, errors, setFieldValue, handleBlur },
  label,
  id,
  ...rest
}) => {
  const { name } = fields;
  const handleChange = (e) => {
    const { checked } = e.target;
    setFieldValue(name, checked, true);
  };

  return (
    <FormGroup className="flex-grow-1">
      <Label className="label-color" htmlFor={id || name}>
        <Input
          {...fields}
          id={id || name}
          type="checkbox"
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={Boolean(touched[name] && errors[name])}
          {...rest}
        />
        <span style={{ marginLeft: '8px' }}>{label}</span>
      </Label>
      <ErrorMessage
        name={name}
        render={(msg) => <div className="text-danger f-12">{msg}</div>}
      />
    </FormGroup>
  );
};

export default FormikCheckboxField;
